module.exports = __webpack_public_path__ + "static/media/success-icon.be2975ed.svg";